<ng-container *ngIf="visible">
  <p-galleria
    [fullScreen]="true"
    [showItemNavigators]="true"
    [circular]="true"
    [showThumbnails]="false"
    [activeIndex]="currentImage"
    [value]="imageUrls"
    [visible]="visible"
    (activeIndexChange)="onActiveIndexChange($event)"
    (visibleChange)="close($event)"
  >
    <ng-template pTemplate="item" let-item>
      <div class="viewer-container">
        <ng-container *ngIf="isPdf(currentImage); else imageBlock">
          <div *ngIf="pdfLoading" class="pdf-loading-container">
            <i class="pi pi-spin pi-spinner pdf-spinner"></i>
          </div>
          <iframe
            *ngIf="!pdfLoading && pdfBlobUrl"
            [src]="pdfBlobUrl"
            class="pdf-viewer"
            [attr.title]="imageNames[currentImage] || 'PDF preview'"
            frameborder="0">
          </iframe>
        </ng-container>
        <ng-template #imageBlock>
          <div *ngIf="!imageLoaded" class="loading-container">
            <i class="pi pi-spin pi-spinner loading-spinner"></i>
          </div>
          <img
            [src]="item"
            [attr.alt]="imageNames[currentImage] || 'Screenshot'"
            class="carousel-image"
            crossorigin="anonymous"
            [class.carousel-image--hidden]="!imageLoaded"
            (load)="imageLoaded = true" />
        </ng-template>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <div class="carousel-header">
        <span class="name">{{ imageNames[currentImage] }}</span>
        <div class="actions">
          <span class="action-btn" role="button" (click)="downloadCurrentImage()" (keyup.enter)="downloadCurrentImage()" (keyup.space)="downloadCurrentImage()" tabindex="0">
            <i class="pi pi-download"></i>
            Download
          </span>
          <span class="action-btn" role="button" (click)="close(false)" (keyup.enter)="close(false)" (keyup.space)="close(false)" tabindex="0">
            <i class="pi pi-times"></i>
            Close
          </span>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <div class="carousel-footer">
        <span class="img-indicator">{{currentImage + 1}}&nbsp;/&nbsp;{{imageUrls.length}}</span>
      </div>
    </ng-template>
  </p-galleria>
</ng-container>
